import { FormInstance, type Rule } from "antd/lib/form"
import { TablesEnum } from "~Shared/store/reducers/tableConfigReducer"
import { insertIf } from "~Shared/utils/helper.utils"
import { checkDueInDays, checkMaxNumber, checkMinNumber } from "./utils.rules"

export const createExpenseFilterRules = (formInstance: FormInstance, table?: TablesEnum) => ({
    minAmount: [
        {
            validator: (_rule, value: number | string) => checkMinNumber({ formInstance, value, name: "maxAmount" }),
        },
    ] as Array<Rule>,
    maxAmount: [
        {
            validator: (_rule, value: number | string) => checkMaxNumber({ formInstance, value, name: "minAmount" }),
        },
    ] as Array<Rule>,
    minDate: [...insertIf(table === TablesEnum.ARCHIVE, { required: true })] as Array<Rule>,
    maxDate: [...insertIf(table === TablesEnum.ARCHIVE, { required: true })] as Array<Rule>,
    dueInDays: [
        {
            validator: (_rule, value: number | string) => checkDueInDays(value),
        },
    ] as Array<Rule>,
})
